import React from "react";
import labcoatImg from "../../assets/labcoat.png";

export const MetaTags = ({ title, description, src = labcoatImg }) => [
  <meta key="title" property="og:title" content={title} />,
  <meta key="title" property="og:description" content={description} />,
  <meta property="og:image" content={src} />,
  <meta name="twitter:title" content={title} />,
  <meta name="twitter:description" content={description} />,
  <meta name="twitter:image" content={src} />,
  <meta name="twitter:card" content="summary_large_image" />
];



// WEBPACK FOOTER //
// ./src/components/atoms/SocialTags.js